import { GET_CLIENT, LOAD_CLIENT, UPDATE_CLIENT } from "../actions/types";

const initialState = {
  clients: [],
  addresses: [],
  loadClient: null,
  newClient: {},
};

export default function (state = initialState, action) {
  let companies = state.companies;
  switch (action.type) {
    case GET_CLIENT:
      let clients = state.clients;
      clients = clients.concat(action.payload.allClients);
      let addresses = state.addresses;
      addresses = addresses.concat(action.payload.allAddresses);

      clients.concat(action.payload.allClients);
      return {
        ...state,
        clients,
        addresses,
      };
    case LOAD_CLIENT:
      return {
        ...state,
        loadClient: action.payload,
      };
    case UPDATE_CLIENT:
      return {
        ...state,
        newClient: action.payload,
      };

    default:
      return state;
  }
}
